module.exports = __webpack_public_path__ + "static/media/tiff.d74d2e10.svg";